import React, {useEffect, useState} from 'react';
import {
    Alert,
    Badge,
    Button,
    Card,
    Col,
    Empty,
    Input,
    Layout,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Typography,
} from 'antd';
import {useApiSearchStudentLessons} from "@/api/lesson";
import StudentLayout from "@/components/layout/student/studentLayout";
import LessonCard from "@/pages/student/lessons/take/_section/LessonCard";
import LessonFilter from "@/pages/student/lessons/take/_section/LessonFilter";
import toFaNumber from "@/lib/utils/number";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useApiReadStudentGrade, useApiSearchStudentGrade} from "@/api/grade";
import RenderIf from "@/components/render-if";
import FreeBox from "@/components/box/freeBox";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import MapSelectionBanner from "@/pages/student/lessons/take/_section/chooseFromMap";
import {useApiReadStudentClassroom} from "@/api/classroom";
import LockMapBanner from "@/pages/student/lessons/take/_section/LockMapBanner";
import {DISABLE_STUDENT_MAP} from "@/constants/config";
import nl2br from "react-nl2br";

const {Header, Content, Sider} = Layout;
const {Title, Text} = Typography;
const {Option} = Select;
const {Meta} = Card;


export default function StudentLessonListPage() {

    const [openModalGrade, setOpenModalGrade] = useState(false)
    const [sortBy, setSortBy] = useState('newest');
    const [currentPage, setCurrentPage] = useState(1);
    const [applyFilters, setApplyFilters] = useState()
    const [open, setOpen] = useState(false);
    const [count, setCount] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [searchData, setSearchData] = useState()
    const [loading, setLoading] = useState(false)
    const pageSize = 6;
    const [filters, setFilters] = useState({})
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const [applyingFilters, setApplyingFilters] = useState(false)
    const [defaultFilters, setDefaultFilters] = useState(
        {

            teacher: null,
            topic_id: searchParams.get("topic_id"),
            group_id: searchParams.get("group_id"),
            // grade_id: searchParams.get("grade_id"),
            grade_id: null,
            course_id: searchParams.get("course_id"),
            weekday: [],
            semester_id: null,
            gender: null,
            price: null,
            available_capacity: null,
            classroom_id: searchParams.get("classroom_id"),

        })

    const {data, isPending} = useApiSearchStudentLessons(applyFilters);

    const {data: gradeList, isPending: isPendingGradeList, isSuccess: isSuccessGradeList} = useApiSearchStudentGrade();
    const {data: loadGrade, isPending: isPendingLoadGrade} =
        useApiReadStudentGrade(searchParams.get("grade_id"));

    const {data: classroomData, isPending: isPendingClassroomData} = useApiReadStudentClassroom(filters?.classroom_id);


    useEffect(() => {
        setLoading(true)
        const delaySearch = setTimeout(() => {
            // if (setSearchData) {
            //     setSearchData(inputSearchValue)
            // }
            setCurrentPage(1)

            setLoading(false)
        }, 1000)

        return () => clearTimeout(delaySearch)

    }, [searchData]);


    useEffect(() => {
        if (!searchParams.get("grade_id")) {
            navigate(URLS.student.lessons.chooseGrade)
        }
    }, [searchParams.get("grade_id")]);


    useEffect(() => {
        setFilters(prev => ({
            ...prev,
            ['search']: searchData,
            ['sort_by']: sortBy,
            ['page']: currentPage,
            ['per_page']: perPage,
            ['topic_id']: searchParams.get("topic_id"),
            ['grade_id']: searchParams.get("grade_id"),
            ['course_id']: searchParams.get("course_id"),
            ['classroom_id']: searchParams.get("classroom_id"),

        }));
    }, [
        searchData,
        sortBy,
        currentPage,
        perPage,
        searchParams.get("topic_id"),
        searchParams.get("grade_id"),
        searchParams.get("course_id"),
        searchParams.get("classroom_id"),
    ]);

    useEffect(() => {
        setApplyingFilters(true)
        const delayFilter = setTimeout(() => {
            setSearchParams({
                grade_id: (filters.grade_id || searchParams.get("grade_id")) ?? '',
                // course_id: filters.course_id || searchParams.get("course_id"),
                topic_id: (filters.topic_id || searchParams.get("topic_id")) ?? '',
                classroom_id: (filters.classroom_id || searchParams.get("classroom_id")) ?? '',


            })
            setApplyFilters(filters)
            setApplyingFilters(false)
        }, 100)

        return () => clearTimeout(delayFilter)

    }, [filters])


    const icon = loading ? <Spin size="small"/> : <i className={`icon-magnifying-glass`}></i>

    return (
        <>

            <Modal
                title="انتخاب مقطع"
                closable={{'aria-label': 'بستن'}}
                open={openModalGrade}
                onOk={() => {
                    setOpenModalGrade(false)
                    setSearchParams({grade_id: 1})
                }}
                onCancel={() => setOpenModalGrade(false)}
            >
                <RenderIf condition={isPendingGradeList}>
                    <Spin spinning={true}/>
                </RenderIf>
                <RenderIf condition={isSuccessGradeList}>
                    <Alert type="success" className={'mb-2'} description={'لطفا مقطع تحصیلی خود را انتخاب کنید'}>

                    </Alert>
                    {gradeList?.data?.data?.map((item, i) => (
                        <div key={item.id + 'grade' + i} className={'cursor-pointer'}
                             onClick={() => {
                                 setSearchParams({grade_id: item.id});
                                 setOpenModalGrade(false)
                             }}>
                            <FreeBox>{item.title}</FreeBox>
                        </div>


                    ))}
                </RenderIf>

            </Modal>

            <StudentLayout pageTitle={'انتخاب درس'} backTo={URLS.student.lessons.chooseGrade}>

                <div className={'flex'}>
                    <div>

                        <LessonFilter
                            defaultFilters={defaultFilters}
                            setExportFilters={setFilters}
                            searchValue={searchData}
                            open={open}
                            setCount={setCount}
                            setOpen={setOpen}
                        />
                    </div>

                    <div className={'m-1 w-full'}>
                        <RenderIf condition={!DISABLE_STUDENT_MAP}>
                            <RenderIf condition={!applyFilters?.classroom_id}>
                                <MapSelectionBanner/>
                            </RenderIf>
                            <RenderIf
                                condition={applyFilters?.classroom_id && classroomData?.data?.data?.longitude && classroomData?.data?.data?.latitude}>
                                <LockMapBanner item={classroomData?.data?.data}/>
                            </RenderIf>
                        </RenderIf>


                        <Content className={'w-full'}>


                            <RenderIf condition={loadGrade?.data?.data?.guide}>
                                <Alert className={'mb-2'} type={'info'} showIcon={true}
                                       message={nl2br(loadGrade?.data?.data?.guide)}/>
                            </RenderIf>

                            <Row justify="space-between" align="middle" className={'mb-4'}>

                                <Col>
                                    <Title level={4} style={{margin: 0}}>

                                        <Input suffix={icon} placeholder={'جستجو'}
                                               rootClassName={`md:w-96`}
                                               onChange={
                                                   (e) => {
                                                       setSearchData(e.target.value)
                                                   }
                                               }
                                               value={searchData}
                                        />
                                        <Badge count={count ? toFaNumber(count) : 0}>
                                            <Button
                                                type={count ? 'dashed' : 'default'}
                                                className={'mx-2 mt-1'} onClick={() => setOpen(!open)}
                                                icon={<span className={'icon-filter1'}></span>}>
                                                فیلتر
                                            </Button>
                                        </Badge>

                                    </Title>


                                </Col>

                                <Col>
                                    <Space>
                                        <Text>مرتب‌سازی بر اساس:</Text>
                                        <Select
                                            value={sortBy}
                                            onChange={setSortBy}
                                            style={{width: 150}}
                                        >
                                            <Option value="newest">جدیدترین</Option>
                                            <Option value="price_low">قیمت (کم به زیاد)</Option>
                                            <Option value="price_high">قیمت (زیاد به کم)</Option>
                                            <Option value="capacity">ظرفیت</Option>
                                        </Select>
                                    </Space>
                                </Col>
                            </Row>
                            <div className={'text-center'}>
                                {applyingFilters || isPending && <Spin className={'mb-2'} spinning={true}/>}

                            </div>

                            <Row gutter={[16, 16]}>

                                {data?.data?.data?.map((classItem) => (
                                    <LessonCard classItem={classItem}
                                                key={'lesson-card' + classItem.id}
                                                onClick={() => {
                                                    navigate(sprintf(URLS.student.lessons.takeLesson, {id: classItem.id}))
                                                }}
                                    />
                                ))}
                            </Row>

                            {data?.data?.data?.length === 0 && (
                                <div style={{textAlign: 'center', padding: '60px 0'}}>
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={
                                            <span>
                      هیچ کلاسی یافت نشد
                      <br/>
                      لطفاً فیلترها را تغییر دهید یا عبارت جستجوی دیگری امتحان کنید
                    </span>
                                        }
                                    />
                                </div>
                            )}

                            <PaginationRaw data={data?.data} setPage={setCurrentPage} setPerPage={setPerPage}/>

                        </Content>
                    </div>
                </div>
            </StudentLayout>


        </>

    );
}